/* Batch 34 · fork L
   S18 — on a 3203-07 row (route 1 or 2) sent to Misstatements with no stored "relates" answer: "Answer missing - sent as
         omitted" (the row stays omitted for the amount sent; it never follows a later proposal).
   S19 — the AP aging: a retention payable kept in / left out by the aging listing ("In the aging listing"), and a concluded
         worksheet whose classification changed since: "Classification changed after conclusion" with the accounts. */
import React from "react";
import { useI18n } from "@/contexts/I18nContext";
import { fmtDate } from "@/lib/dt";
import { asArray } from "@/lib/asArray";
import { fmtNumber } from "@/components/Amount";   // STEP 3 · rule 2 · B-2e: the one amount formatter

const NF = { format: (n) => fmtNumber(n) };   // STEP 3 · rule 2 · B-2e
const fill = (s, o) => String(s || "").replace(/\{(\w+)\}/g, (_, k) => (o[k] ?? ""));

export function AnswerMissingNote({ ev, testid }) {
  const { t } = useI18n();
  if (!ev?.answer_missing) return null;
  return (
    <div className="mt-1 rounded bg-amber-100 px-1 text-[11px] text-amber-800 dark:bg-amber-950/40 dark:text-amber-300"
         title={t("b34l.answerMissingHint")} data-testid={testid}>{t("b34l.answerMissing")}</div>
  );
}

export function AgingFitTag({ a }) {
  const { t } = useI18n();
  if (!a?.aging_fit) return null;
  return <span className="ms-1 text-[10px] text-muted-foreground" data-testid={`hfws-acct-fit-${a.coa_id}`}>
    · {a.aging_fit === "included" ? t("b34l.agingIn") : t("b34l.agingOut")}</span>;
}

export function ClassificationChangedBanner({ missing }) {
  const { t, lang } = useI18n();
  const m = asArray(missing).find((x) => x && x.field === "classification_changed");
  if (!m) return null;
  const ch = m.change || {};
  const accounts = Array.isArray(ch.accounts) ? ch.accounts : [];
  const state = (a) => {
    const was = a.was_trade === true ? t("b34l.wasTrade") : a.was_trade === false ? t("b34l.wasNot") : "";
    const now = a.suggested_trade === null || a.suggested_trade === undefined ? t("b34l.needsClass")
      : (a.is_trade ? t("b34l.nowTrade") : t("b34l.nowNot"));
    return [was, now].filter(Boolean).join(" → ");
  };
  return (
    <div className="rounded-md border border-amber-400 bg-amber-50 p-3 text-xs text-amber-900 dark:border-amber-900 dark:bg-amber-950/30 dark:text-amber-200"
         data-testid="hfws-classification-changed">
      <div className="font-semibold">{t("b34l.changedTitle")}</div>
      <div className="mt-1">{t("b34l.changedText")}</div>
      <div className="mt-1 text-[11px]">
        {ch.concluded_at ? fill(t("b34l.changedAt"), { d: fmtDate(ch.concluded_at) }) : ""}
        {ch.difference_at_conclusion !== null && ch.difference_at_conclusion !== undefined
          ? ` · ${fill(t(ch.baseline ? "p53s.diffBaseline" : "b34l.diffThen"), { v: NF.format(ch.difference_at_conclusion) })}` : ""}
        {ch.difference_now !== null && ch.difference_now !== undefined ? ` · ${fill(t("b34l.diffNow"), { v: NF.format(ch.difference_now) })}` : ""}
      </div>
      {accounts.length > 0 && (
        <ul className="mt-1 list-disc ps-5 text-[11px]" dir={lang === "ar" ? "rtl" : "ltr"}>
          {accounts.map((a) => (
            <li key={a.coa_id || a.code} data-testid={`hfws-changed-${a.code}`}>
              <span className="font-mono">{a.code}</span> {a.name} · {NF.format(Number(a.balance) || 0)} · {state(a)}
            </li>))}
        </ul>)}
    </div>
  );
}
